





















































































































































































































































































































































































































































































































































































































import { SfTabs, SfLink } from '@storefront-ui/vue';
import { defineComponent, ref, computed, useRouter, useContext } from '@nuxtjs/composition-api';
import useCustForm from '~/modules/czar/formquery/customForm';
import { getMetaInfo } from '~/helpers/getMetaInfo';

export default defineComponent({
    name: 'GovernmentandEDU',
    components: {
        SfTabs,
        SfLink
    },
    setup() {
        const { useCustFormData } = useCustForm();
        const fullname = ref('');
        const organization = ref('');
        const email = ref('');
        const telephone = ref('');
        const applies = ref('');
        const description = ref('');
        const base64_encoded_file = ref(<any>'');
        const name = ref('');
        var queryVariables = {};
        const showAlert = ref(false);
        const resultcust = ref<any | null>(null);
        const router = useRouter();
        const { app } = useContext();

        const previewFiles = (event: InputEvent) => {
            const target = event.target as HTMLInputElement;
            const file: File = (target.files as FileList)[0];
            name.value = file.name;
            const size = file.size;
            if (size < 50 * 1024 * 1024) {
                toBase64(file).then(data => base64_encoded_file.value = data);
            } else {
                name.value = null;
                base64_encoded_file.value = null;
                alert("To large file for upload, please upload small file");
            }
        };

        /* const previewFiles = (event) => {
            const file = event.target.files[0];
            if (file) {
                file.value = file;
                name.value = file.name;
            } else {
                file.value = null;
                name.value = '';
            }
        }; */

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.toString().split(',')[1]; // Extracting base64 string
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });

        const commercialform = () => {
            if (fullname.value && email.value && organization.value && telephone.value && applies.value) {
                if (name.value && base64_encoded_file.value) {
                    queryVariables = {
                        form_type: 'commercial_government',
                        fullname: fullname.value,
                        email: email.value,
                        files: [{
                            name: name.value,
                            base64_encoded_file: base64_encoded_file.value
                        }],
                        organization: organization.value,
                        telephone: telephone.value,
                        applies: applies.value,
                        description: description.value,
                    }
                } else {
                    queryVariables = {
                        form_type: 'commercial_government',
                        fullname: fullname.value,
                        email: email.value,
                        organization: organization.value,
                        telephone: telephone.value,
                        applies: applies.value,
                        description: description.value,
                    }
                }
                resultcust.value = useCustFormData(queryVariables).then(response => {
                   
                }).catch((error) => {
                    
                }).finally(() => {
                    showAlert.value = true;
                    fullname.value = '';
                    email.value = '';
                    name.value = '';
                    base64_encoded_file.value = '';
                    organization.value = '';
                    telephone.value = '';
                    applies.value = '';
                    description.value = '';
                });
            } else {
                if (!fullname.value) {
                    alert('Please enter Name (First & Last).')
                } else if (!email.value) {
                    alert('Please enter Email.')
                } else if (!organization.value) {
                    alert('Please enter Organization/School.')
                } else if (!telephone.value) {
                    alert('Please enter Phone Number.')
                } else if (!applies.value) {
                    alert('Please select Applies.')
                } else {
                    alert('Please enter All Requerd Field')
                }
            }
        };

        const educationalform = async () => {
            if (fullname.value && email.value && organization.value && telephone.value && applies.value) {
                if (name.value && base64_encoded_file.value) {
                    queryVariables = {
                        form_type: 'education',
                        fullname: fullname.value,
                        email: email.value,
                        files: [{
                            name: name.value,
                            base64_encoded_file: base64_encoded_file.value
                        }],
                        organization: organization.value,
                        telephone: telephone.value,
                        applies: applies.value
                    }
                } else {
                    queryVariables = {
                        form_type: 'education',
                        fullname: fullname.value,
                        email: email.value,
                        organization: organization.value,
                        telephone: telephone.value,
                        applies: applies.value
                    }
                }
                /* resultcust.value = computed(() => (useCustFormData(queryVariables))); */
                resultcust.value = useCustFormData(queryVariables).then(response => {
                   
                }).catch((error) => {

                }).finally(() => {
                    showAlert.value = true;
                    fullname.value = '';
                    email.value = '';
                    name.value = '';
                    base64_encoded_file.value = '';
                    organization.value = '';
                    telephone.value = '';
                    applies.value = '';
                });
                
            } else {
                if (!fullname.value) {
                    alert('Please enter Name (First & Last).')
                } else if (!email.value) {
                    alert('Please enter Email.')
                } else if (!organization.value) {
                    alert('Please enter Organization/School.')
                } else if (!telephone.value) {
                    alert('Please enter Phone Number.')
                } else if (!applies.value) {
                    alert('Please select Applies.')
                } else {
                    alert('Please enter All Requerd Field')
                } 
            }
        };

        const hideAlert = async () => {
            showAlert.value = false;
            const homePath = app.localeRoute({ name: 'home' });
            await router.push(homePath);
        }

        const activeTabChanged = (newActiveTab) => {
            const customAttribute = newActiveTab.title;
            return customAttribute;
        };

        const customactivetab = ref(1);
        const activeTab = computed((tab) => {
            return customactivetab.value;
        });

        const tab_nav_clicked = (tab) => {
            customactivetab.value = tab;
        };

        const removeFile = () => {
            name.value = null;
            base64_encoded_file.value = null;
        };

        const pageMeta = {
            "meta_title": null,
            "meta_description": null,
            "meta_keywords": null,
            "name": "Midwest Photo Commercial,Government and EDU",
        };

        return {
            commercialform,
            educationalform,
            fullname,
            organization,
            email,
            telephone,
            applies,
            description,
            previewFiles,
            base64_encoded_file,
            queryVariables,
            hideAlert,
            resultcust,
            showAlert,
            activeTab,
            tab_nav_clicked,
            activeTabChanged,
            customactivetab,
            removeFile,
            name,
            pageMeta
        };
    },
    head() {
        return getMetaInfo(this.pageMeta);
    },
});
